import { Spacer } from 'app/layouts/generic';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { AffiliateAccountDetails } from 'app/member/affiliate/dashboard/account';
import { AffiliateEarnings } from 'app/member/affiliate/dashboard/earnings';
import { AffiliateEarningsReport } from 'app/member/affiliate/dashboard/report';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPageTitle } from 'store/actions/header';

export const AgentModule = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setPageTitle([
        { title: 'Settings', path: '/settings' },
        { title: 'Agent Dashboard', path: '/settings/agent' }
      ])
    );
  }, []);

  return (
    <>
      <GridRow num_of_columns={4}>
        <GridColumn>
          <AffiliateAccountDetails />
        </GridColumn>
        <GridColumn span={3}>
          <AffiliateEarningsReport />
          <Spacer multiple={4} />
          <AffiliateEarnings />
        </GridColumn>
      </GridRow>
    </>
  );
};
